import { ConfigApi } from './Constantes';

if (!ConfigApi.baseURL) {
  ConfigApi.baseURL = `${`${window.location.protocol}//${window.location.hostname}`}:${
    ConfigApi.port
  }`;
}
